import PreviewTypes from './PreviewTypes.enum';

export default Object.freeze([
	{
		type: PreviewTypes.Label,
		text: 'Label',
	},
	{
		type: PreviewTypes.Envelope,
		text: 'Envelope',
	},
	{
		type: PreviewTypes.ReturnLabel,
		text: 'Return Label',
	},
]);
